import pins from './pin'

const testing = {
    pins,
}

export default testing